"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toQueryParams = exports.wrappedFetch = exports.isOnline = exports.isOnlineCheckInterval = void 0;
const utils_1 = require("./utils");
let isAppOnline = true;
/**
 * Helper function to check online status
 */
exports.isOnlineCheckInterval = setInterval(async () => {
    if (isAppOnline) {
        return;
    }
    try {
        const response = await fetch('https://buildcore.io', { method: 'HEAD' });
        isAppOnline = response.ok;
    }
    catch (_a) {
        isAppOnline = false;
    }
}, 1000);
/**
 * Promise based function to provide online status.
 *
 * @returns
 */
const isOnline = () => {
    if (isAppOnline) {
        return Promise.resolve();
    }
    return new Promise((resolve) => {
        const checkInterval = setInterval(() => {
            if (isAppOnline) {
                clearInterval(checkInterval);
                resolve();
            }
        }, 1000);
    });
};
exports.isOnline = isOnline;
/**
 * Wrapped fetch function to inject bearer and process responses
 *
 * @param token
 * @param url
 * @param params
 * @returns
 */
const wrappedFetch = async (token, url, params) => {
    try {
        await (0, exports.isOnline)();
        const r = await fetch(url + (0, exports.toQueryParams)(params), {
            headers: { Authorization: 'Bearer ' + token },
        });
        const json = await r.json();
        if (Array.isArray(json)) {
            return (0, utils_1.processObjectArray)(json);
        }
        return (0, utils_1.processObject)(json);
    }
    catch (error) {
        isAppOnline = false;
        throw error;
    }
};
exports.wrappedFetch = wrappedFetch;
/**
 * Convert object into query params
 *
 * @param params
 * @returns
 */
const toQueryParams = (params) => {
    let query = '';
    for (const entry of Object.entries(params)) {
        if (entry[1] === undefined) {
            continue;
        }
        if (Array.isArray(entry[1])) {
            for (const value of entry[1]) {
                query += `&${entry[0]}[]=${value}`;
            }
            continue;
        }
        query += `&${entry[0]}=${entry[1]}`;
    }
    return query.replace('&', '?');
};
exports.toQueryParams = toQueryParams;
